import * as React from "react";
import { useState } from "react";
import { Button } from "components/bootstrap";
import { Spinner } from "components/common";
import AuthenticationDomain from "../domainActions/AuthenticationDomain";
const TriggerTeamSyncButton = ({ backendId, backendTitle, setResponse }) => {
  const [loading, setLoading] = useState(false);
  const _triggerTeamSync = () => {
    if (
      // eslint-disable-next-line no-alert
      window.confirm(
        "Do you really want to trigger the group synchronization? Already synchronized teams will may get deleted if the group sync config changed. You can test the configuration on the edit page."
      )
    ) {
      setResponse(void 0);
      setLoading(true);
      AuthenticationDomain.triggerTeamSync(backendId, backendTitle).then((response) => {
        setResponse(response);
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      });
    }
  };
  return /* @__PURE__ */ React.createElement(Button, { onClick: _triggerTeamSync, type: "button", bsStyle: "info", bsSize: "small" }, loading && /* @__PURE__ */ React.createElement(Spinner, { text: " " }), "Trigger Synchronization");
};
export default TriggerTeamSyncButton;
